import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/expressive.css'; // Material 3 Expressive Design utilities
import App from './App';
import { ThemeProvider } from './contexts/ThemeContext';
import { DrawerProvider } from './contexts/DrawerContext';
import { registerChunkLoadRecovery } from './utils/chunkLoadRecovery';

// Auto-recover from "Loading chunk X failed" after deploys/caching issues.
registerChunkLoadRecovery();

// Register Service Worker for PWA functionality (disabled in development)
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('[Service Worker] Registered successfully:', registration.scope);
        
        // Check for updates periodically
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000); // Check every hour
      })
      .catch((error) => {
        console.warn('[Service Worker] Registration failed:', error);
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <DrawerProvider>
        <App />
      </DrawerProvider>
    </ThemeProvider>
  </React.StrictMode>
);
